/**
 * GBA/ITC Gateway API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CompanyFacilityDto { 
    id: string;
    name: string;
    supplyChainClusters: Array<CompanyFacilityDto.SupplyChainClustersEnum>;
    /**
     * Facility location as GeoJSON string
     */
    location?: string;
}
export namespace CompanyFacilityDto {
    export const SupplyChainClustersEnum = {
        Mining: 'mining',
        Refining: 'refining',
        AdvancedMaterials: 'advanced-materials',
        BatteryComponents: 'battery-components',
        BatteryAssembly: 'battery-assembly'
    } as const;
    export type SupplyChainClustersEnum = typeof SupplyChainClustersEnum[keyof typeof SupplyChainClustersEnum];
}


